export enum ContractFormFieldNames {
  WORK_STATUS = 'status',
  TYPE = 'type',
  UNIT_NUMBER = 'vatNumber',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
}
